var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavTasks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.085,
    height: 19.661,
    viewBox: "0 0 19.085 19.661",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2103",
    "data-name": "Path 2103",
    d: "M195.511,105.059h-2.679v-.708a.528.528,0,0,0-1.056,0v.708h-6.707v-.708a.528.528,0,0,0-1.056,0v.708h-2.679a2.206,2.206,0,0,0-2.2,2.2v13.519a2.206,2.206,0,0,0,2.2,2.2H195.51a2.206,2.206,0,0,0,2.2-2.2V107.262a2.206,2.206,0,0,0-2.2-2.2Zm-15.325,2.2a1.148,1.148,0,0,1,1.147-1.147h2.679v.708a.528.528,0,0,0,1.056,0v-.708h6.707v.708h0a.528.528,0,0,0,1.056,0v-.708h2.679a1.148,1.148,0,0,1,1.147,1.147v3.19H180.185Zm15.325,14.668H181.332a1.148,1.148,0,0,1-1.147-1.149V111.5h16.472v9.279a1.148,1.148,0,0,1-1.147,1.149Z",
    transform: "translate(-178.879 -103.573)",
    stroke: "#323232",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavTasks);
export default __webpack_public_path__ + "static/media/Nav-Tasks.ac0ec5b4124801bad0b39e21b61d29b6.svg";
export { ForwardRef as ReactComponent };